@import '@hevoio/hevo-ui-toolkit/styles/variables';

.defaultWarehouseTag {
  border: 0;
  font-weight: $font-weight-bold;
  background: $hover-bg;
  color: $text-secondary;
  padding: 0 $spacer * 0.25 !important;
}

.errorCaption {
  color: $error !important;
}
